import React, { useState } from "react";
import { useSystemId } from "../../../../hooks/useReduxSelectors";
import { Box, Grid, Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { AlarmLimits } from "../../../../actions/apiActions";
import { useKeyboard } from "../../../../hooks/KeyboardContext";
import { surface, status, kontram } from "../../../../../theme/muiTheme";

// For testing
export const inputValidationCheck = (alarm) => {
  let validationSuccess = true;
  let newAlarmObject = {
    HwId: alarm.hwId,
    ValueName: alarm.valueName,
    delay: alarm.delay
  };
  try {
    if ((alarm.lowWarning !== undefined) && (alarm.lowWarning !== null)) {
      newAlarmObject.lowWarning = Number(alarm.lowWarning.toString().replace(/\,/g, "."));
    }
    if ((alarm.highWarning !== undefined) && (alarm.highWarning !== null)) {
      newAlarmObject.highWarning = Number(alarm.highWarning.toString().replace(/\,/g, "."));
    }
    if ((alarm.lowAlarm !== undefined) && (alarm.lowAlarm !== null)) {
      newAlarmObject.lowAlarm = Number(alarm.lowAlarm.toString().replace(/\,/g, "."))
    }
    if ((alarm.highAlarm !== undefined) && (alarm.highAlarm !== null)) {
      newAlarmObject.highAlarm = Number(alarm.highAlarm.toString().replace(/\,/g, "."))
    }
    if ((alarm.delay !== undefined) && (alarm.delay !== null)) {
      newAlarmObject.delay = Number(alarm.delay.toString().replace(/\,/g, "."))
    }
    Object.values(newAlarmObject).map((value, idx) => {
      if (Number.isNaN(value)) {
        validationSuccess = false;
      }
    })
  } catch (e) {
    console.log(e)
  }
  if (validationSuccess === true) {
    return newAlarmObject;
  } else {
    return "error"
  }
}

const EditRangesDetail = ({ alarm, isDeactivated, config, onChangeHandler, saveForm, restoreValuesAndUpdateForm, solutionType }) => {

  const { registerInput } = useKeyboard();
  const systemId = useSystemId();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [errorMsg, setErrorMsg] = useState("")

  const resetRequest = () => {
    try {
      setIsModalOpen(false)
      setErrorMsg("")
      const params = { systemId, HwId: alarm.hwId, ValueName: alarm.valueName }
      restoreValuesAndUpdateForm(params)
    } catch (e) {
      setErrorMsg("Restore Error");
    }
  }

  const saveAlarmLimits = (alarm) => {
    const saveRequest = async (payload) => {
      try {
        const response = await AlarmLimits.update(config.DATA_URL, payload)
        saveForm();
        setErrorMsg("Save successful");
      } catch (e) {
        setErrorMsg("Save error. Something went wrong");
      }
    }

    const params = inputValidationCheck(alarm);
    if (params === "error") {
      setErrorMsg("Save error. Inputs were not valid");
    } else {
      const currentDeactivatedState = typeof isDeactivated === "boolean"
        ? isDeactivated
        : Boolean(alarm?.deactivated);

      let payload = {
        ...params,
        Deactivated: currentDeactivatedState,
        CustomAlarm: Boolean(alarm?.customAlarm),
        CustomerId: (config && config.CUSTOMER_ID) || "",
        DeviceId: (config && config.DEVICE_ID) || "",
        isLoraDevice: solutionType === "lora" ? true : false,
      }
      setErrorMsg("");
      saveRequest(payload);
    }
  }
  let delayValues = true;
  let lowValues = false;
  let highValues = false;
  let warningValues = false;
  let alarmValues = false;

  if (alarm) {
    if (alarm.customAlarm) {
      // For custom alarms, always show all input fields
      lowValues = true;
      highValues = true;
      warningValues = true;
      alarmValues = true;
      delayValues = true;
    } else {
      // if ((alarm.delayWarning) || (alarm.delayAlarm)) {
      //   delayValues = true;
      // }
      if (((alarm.highWarning !== undefined) && (alarm.highWarning !== null)) || ((alarm.highAlarm !== undefined) && (alarm.highAlarm !== null))) {
        highValues = true
      }
      if (((alarm.lowWarning !== undefined) && (alarm.lowWarning !== null)) || ((alarm.lowAlarm !== undefined) && (alarm.lowAlarm !== null))) {
        lowValues = true
      }
      if (((alarm.lowWarning !== undefined) && (alarm.lowWarning !== null)) || ((alarm.highWarning !== undefined) && (alarm.highWarning !== null))) {
        warningValues = true
      }
      if (((alarm.lowAlarm !== undefined) && (alarm.lowAlarm !== null)) || ((alarm.highAlarm !== undefined) && (alarm.highAlarm !== null))) {
        alarmValues = true
      }
    }
  }

  const editDetailSx = { px: 2 };

  const editTitleSx = {
    fontSize: "18px",
    letterSpacing: "1px",
    textAlign: "center",
    display: "inline-block",
  };

  const inputSx = {
    bgcolor: surface.panel,
    border: `1px solid ${surface.mutedBorder}`,
    borderRadius: "4px",
    color: "common.white",
    fontSize: "16px",
    p: "6px 10px",
    width: "100%",
    "&:focus": { outline: "none", borderColor: "primary.main" },
  };

  // Fixed width keeps a Low/High column the same size in the header row and every value row, so labels stay lined up with their fields.
  const valueColumnSx = { width: 110, flexShrink: 0 };

  const modal = () => {
    return (
      <Dialog
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        maxWidth="sm"
        fullWidth
        id="confirmActionModal"
      >
        <DialogContent>
          <Box sx={{ textAlign: "center" }}>
            <h3>Reset</h3>
            <h4 style={{ color: status.warning }}>{`${alarm.hwId} / ${alarm.valueName}`}</h4>
            <h4>alarm values to factory default?</h4>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="secondary" onClick={() => setIsModalOpen(false)}> NO </Button>
          <Button variant="contained" color="primary" onClick={() => resetRequest()}> YES </Button>
        </DialogActions>
      </Dialog>
    )
  }

  return (
    <>
      <Box sx={editDetailSx}>
        {modal()}
        <Grid container sx={{ my: 1.5, columnGap: 2 }} >
          <Grid size={{ xs: 2, sm: 3 }}><Box component="span" sx={{ ...editTitleSx, visibility: "hidden" }}>HIDDEN</Box></Grid>
          {lowValues && <Grid sx={valueColumnSx}><Box component="span" sx={editTitleSx}>Low</Box></Grid>}
          {highValues && <Grid sx={valueColumnSx}><Box component="span" sx={editTitleSx}>High</Box></Grid>}
        </Grid>
        {warningValues &&
          <Grid container sx={{ my: 1.5, columnGap: 2 }}>
            <Grid size={{ xs: 2, sm: 3 }}><Box component="span" sx={{ ...editTitleSx, color: status.warning, ml: 1 }}>Warning</Box></Grid>
            {lowValues &&
              <Grid sx={valueColumnSx}>
                <Box
                  component="input"
                  type="text"
                  value={alarm.lowWarning ?? ""}
                  sx={inputSx}
                  onChange={(e) => onChangeHandler("lowWarning", e.target.value, alarm.frontendId)}
                  onClick={() => registerInput(alarm.frontendId + "|lowWarning", alarm.lowWarning ?? "", (v) => onChangeHandler("lowWarning", v, alarm.frontendId))}
                />
              </Grid>
            }
            {highValues &&
              <Grid sx={valueColumnSx}>
                <Box
                  component="input"
                  type="text"
                  sx={inputSx}
                  value={alarm.highWarning ?? ""}
                  onChange={(e) => onChangeHandler("highWarning", e.target.value, alarm.frontendId)}
                  onClick={() => registerInput(alarm.frontendId + "|highWarning", alarm.highWarning ?? "", (v) => onChangeHandler("highWarning", v, alarm.frontendId))}
                />
              </Grid>
            }
          </Grid>
        }
        {alarmValues &&
          <Grid container sx={{ my: 1.5, columnGap: 2 }}>
            <Grid size={{ xs: 2, sm: 3 }}><Box component="span" sx={{ ...editTitleSx, color: status.alarmLabel, ml: 1 }}>Alarm</Box></Grid>
            {lowValues &&
              <Grid sx={valueColumnSx}>
                <Box
                  component="input"
                  type="text"
                  sx={inputSx}
                  value={alarm.lowAlarm ?? ""}
                  onChange={(e) => onChangeHandler("lowAlarm", e.target.value, alarm.frontendId)}
                  onClick={() => registerInput(alarm.frontendId + "|lowAlarm", alarm.lowAlarm ?? "", (v) => onChangeHandler("lowAlarm", v, alarm.frontendId))}
                />
              </Grid>
            }
            {highValues &&
              <Grid sx={valueColumnSx}>
                <Box
                  component="input"
                  type="text"
                  sx={inputSx}
                  value={alarm.highAlarm ?? ""}
                  onChange={(e) => onChangeHandler("highAlarm", e.target.value, alarm.frontendId)}
                  onClick={() => registerInput(alarm.frontendId + "|highAlarm", alarm.highAlarm ?? "", (v) => onChangeHandler("highAlarm", v, alarm.frontendId))}
                />
              </Grid>
            }
          </Grid>
        }
        {delayValues &&
          <Grid container sx={{ my: 1.5, columnGap: 2, borderTop: "1px solid black" }}>
            <Grid size={{ xs: 2, sm: 3 }} sx={{ mt: 1.5 }}><Box component="span" sx={{ ...editTitleSx, ml: 1 }}>Delay</Box></Grid>
            <Grid sx={{ ...valueColumnSx, mt: 1.5 }}>
              <Box
                component="input"
                type="text"
                sx={inputSx}
                value={alarm.delay ?? ""}
                onChange={(e) => onChangeHandler("delay", e.target.value, alarm.frontendId)}
                onClick={() => registerInput(alarm.frontendId + "|delay", alarm.delay ?? "", (v) => onChangeHandler("delay", v, alarm.frontendId))}
              />
            </Grid>
            <Grid sx={{ mt: 1.5 }}>
              {errorMsg === "Save successful" ?
                <p style={{ color: kontram.primary, fontSize: "19px" }}>{errorMsg}</p>
                :
                <p style={{ color: kontram.red, fontSize: "18px" }}>{errorMsg}</p>
              }
            </Grid>
          </Grid>
        }
      </Box>
      <Grid container sx={{ my: 1.5, px: 2 }}>
        <Grid size={{ sm: 12, md: 5, lg: 4, xl: 3 }} sx={{ display: "flex", justifyContent: "center" }} >
          {(solutionType !== "lora" && !alarm.customAlarm) &&
            <Button variant="outlined" color="secondary" onClick={() => { setIsModalOpen(true) }}>
              RESTORE
            </Button>}
        </Grid>
        <Grid size={{ sm: 12, md: 5, lg: 4, xl: 3 }} offset={{ md: 2, lg: 4, xl: 6 }} sx={{ display: "flex", justifyContent: "center" }}>
          <Button variant="contained" color="primary" onClick={() => { saveAlarmLimits(alarm) }}>
            SAVE
          </Button>
        </Grid>
      </Grid>
    </>
  );
};



export default EditRangesDetail;